export default "__VITE_ASSET__C8lKkY6P__"